import { cn } from './cn';
import { Button } from './Button';

/**
 * A failed fetch, with the retry a reader needs. The message is always supplied by the
 * caller in the active locale — an English "Something went wrong" on an Assamese page is
 * the tell that a site was translated rather than built bilingual (§1.15).
 */
export function ErrorState({
  title,
  body,
  retryLabel,
  onRetry,
  className,
}: {
  title: string;
  body?: string;
  retryLabel?: string;
  onRetry?: () => void;
  className?: string;
}) {
  return (
    <div
      role="alert"
      className={cn(
        'flex flex-col items-center gap-3 rounded-lg border border-line bg-white px-6 py-12 text-center',
        className,
      )}
    >
      <svg
        viewBox="0 0 24 24"
        width="28"
        height="28"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        className="text-red"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7.5v5.5M12 16.2v.3" strokeLinecap="round" />
      </svg>
      <h3 className="text-xl font-extrabold">{title}</h3>
      {body && <p className="max-w-sm text-base text-body">{body}</p>}
      {onRetry && retryLabel && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          {retryLabel}
        </Button>
      )}
    </div>
  );
}
